module.exports = {
  bg: "#fff",
  // The page background. Not #fff: MUI v3's CssBaseline painted the body from
  // palette.background.default, whose v3 default was #fafafa, and that is the
  // shade the site has always shipped.
  pageBg: "#fafafa",
  white: "#fff",
  accent: "#f1d624",
  blue: "#4d13d1",
  bright: "#fff",
  dark: "#333",
  gray: "#555",
  lightGray: "#bbb",
  superLightGray: "#dedede",
  mediocreLightGray: "#cecece",
  grayishBlue: "#cadee4",
  BLDRgray: "#292929",
  BLDRYellow: "#f1d624"
};
